import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "img-puzzle-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", stroke: "currentColor" },
        React.createElement("path", { d: "M10.5 8.5a5 5 0 1 1-5.512-4.974l.537-.027C8.261 3.5 10.5 5.74 10.5 8.5Z" }),
        React.createElement("path", { d: "M16.5 8.5a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z" }),
        React.createElement("path", { fill: "currentColor", fillOpacity: 0.2, fillRule: "evenodd", d: "M10.5 8.5a4.99 4.99 0 0 1-2 4 4.988 4.988 0 0 1-2-4 4.99 4.99 0 0 1 2-4 4.99 4.99 0 0 1 2 4Z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
